<router-outlet>
	<app-loading-spinner></app-loading-spinner>
</router-outlet>
